import { AssetDropDown } from "../UiComponents/AssetDropDown";
import { getAssestListddlAction } from "../actions/assetsddlAction";
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect, useRef, useMemo, Component } from 'react'
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { getAsset } from "../actions/assetAction";
import { useParams, useNavigate } from 'react-router-dom'
import moment from "moment";
import { sbaAxios } from '../utils/sbaAxios';
import { getpricinglist, postpricingdata, DeletePricing } from "../../config/apiConfig";
import { getAssetPricingAction } from "../actions/pricingAction";
import { AgGridReact } from "ag-grid-react";
import { SBDatePicker } from "../UiComponents/SBDatePicker";
import { BreadCrumbs } from "../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../config/routeConfig";
import { TopBar } from "../shared/topBar/TopBar";
import { LoadingScreen } from "../UiComponents/LoadingComponent";
import { ToastContainer, toast } from 'react-toastify';
import { getAssetAttributes } from "../actions/assetAttributesActions";
import { useLocation } from 'react-router-dom';
export const ValuationPostPricing = () => {
  const gridRef=useRef();
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  const dispatch = useDispatch();
  const history = useNavigate();
  const params = useParams();
  const location = useLocation();

  const currentDate = new Date();
  const firstDayOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfPreviousMonth = new Date(firstDayOfCurrentMonth.getTime() - 1);

  const [SelectedDate, setSelectedDate] = useState(location.state && location.state.PricingDate !== null
    ? location.state.PricingDate
    : lastDayOfPreviousMonth);
  const [selectedAssetid, setSelectedAssetid] = useState(params.AssetId);
  const [hideZeroPosition, SetHideZeroPosition] = useState(location.state && location.state.HideZeroBalance !== null
    ? location.state.HideZeroBalance
    :true);
  const [hidePortfolios, SetHidePortfolios] = useState(location.state && location.state.HideActivePortfolios !== null
    ? location.state.HideActivePortfolios
    :false);
  const [pricingData, setPricingData] = useState();
  const AssetListDDL = Gstate.assetDDL.assetList || [];

  const firstDateOfMonth = new Date(SelectedDate.getFullYear(), SelectedDate.getMonth(), 1);
  const lastDateOfMonth = new Date(SelectedDate.getFullYear(), SelectedDate.getMonth() + 1, 0);
  const lastDateOfPreviousMonth = new Date(firstDateOfMonth.getFullYear(), firstDateOfMonth.getMonth(), 0);
  const isPricinggridLoading = Gstate.AssetpricingList.isPricingLoading;
  const currentAsset = Gstate.asset.asset || {};
  const [Loading, setLoading] = useState(false);
  const [portfolioIds, setportfolioIds] = useState([]);
  const [valuationDateChange,setValuationDateChange]=useState(0);

  let LocalDate = SelectedDate;
  const UserId = useSelector(state => state.common.userDetails.UserId);
  const pricinglist = Gstate.AssetpricingList.AssetpricingList || [];
  const formattedSelectDate = moment(LocalDate).format("MM-DD-yyyy");
  const Attributes = Gstate.attributesDetails.attributesDetails || {};

  const ismarket = Attributes.IsMarketable;
  //
    const HF = [1, 2, 5, 11, 12, 17]; //Temp Fix added to make PE run with HE mode
  const PE = [2, 5, 17];
  const AssetType = currentAsset?.SecurityTypeId || 0;
  useEffect(() => {
    dispatch(getAssetAttributes(params.AssetId));
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.AssetId));
    dispatch(getAssetPricingAction(params.AssetId, formattedSelectDate));

  }, []);
    const PriceDatechange = (e) => {
    setSelectedDate(e.toDate());
    
  };
  useEffect(()=>{
    if(valuationDateChange>0)
    {
      gobtnClick();
    }
  },[valuationDateChange]);

  const priceDateOnBlur=(e)=>{
    const date=moment(e).format("MM-DD-yyyy");
    if(date !='Invalid date');
    getValuationDataByAssetAndDate(selectedAssetid,date);
  }
  const priceDateOnClose=(e)=>{
    setValuationDateChange(val=>val+1);
  };
  const AssetDDChanged = (e) => {
    if (e.value) {
      history(`${UrlPath.ValuationPostPricing}${e.value.AssetId}`);
      e.value && dispatch(getAsset(e.value.AssetId));
      getValuationDataByAssetAndDate(e.value.AssetId,formattedSelectDate);
      setSelectedAssetid(e.value.AssetId);
    }

  }
  const gobtnClick = () => {
    dispatch(getAssetPricingAction(selectedAssetid, formattedSelectDate));
    getPricingData(hideZeroPosition);
  }

  const getValuationDataByAssetAndDate= (assetId,date) => {
    dispatch(getAssetPricingAction(assetId, date));
    getPricingData(hideZeroPosition);
}

  const dateValueFormatter = (params) => {
    return params.value !== null
      ? moment(params.value).format("MM/DD/YYYY")
      : "";
  };

  const currencyValueFormatter = (params) => {
    const formattedValue = params.value?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formattedValue ? `$ ${formattedValue}` : "";
  };


  const percentageValueFormatter = (params) => {
    if (params.value !== null) {
      return `% ${params.value}`;
    } else {
      return "";
    }
  };

  const createRow = (entity, parentIndex, childIndex) => {
    const {
      PortfolioName,
      PortfolioId,
      PostedBy,
      PostedOn,
      PriorMonthEMV,
      BMV,
      EMV,
      Flows,
      NAV,
      Shares,
      Return,
      IsActual,
      IsShareBased,
      ReturnValue,
      ShareClassId,
      ShareClassName,
      ValuationDate,
      AssetLotName,
      AssetLotId,
      PricingLotList,
    } = entity || {};

    const isChild = typeof childIndex === 'number';
    const isUpdated = false;
    const CurAllocation = isChild
      ? PricingLotList?.find((allocation) => allocation?.Position)?.Position || null
      : null;

    const PerAllocation = isChild ? 100 : null;
    const parentPortfolioName = isChild ? PortfolioName : null;
    const newReturn = isChild ? ReturnValue : Return;

    return {
      PortfolioName,
      PortfolioId,
      PostedBy,
      PostedOn,
      PriorMonthEMV: PriorMonthEMV === null ? 0 : PriorMonthEMV,
      BMV: BMV === null ? 0 : BMV,
      EMV: EMV === null ? 0 : EMV,
      Flows,
      newReturn,
      NAV,
      Shares,
      IsActual,
      IsShareBased,
      ShareClassId,
      ShareClassName,
      ValuationDate,
      AssetLotName,
      AssetLotId,
      CurAllocation,
      PerAllocation,
      parentPortfolioName,
      isChild,
      isUpdated,
      childIndex,
      PricingLotList
    };
  };




  const getPricingData = (IsHide) => {
    const rowData = pricinglist?.flatMap((allocation, parentIndex) => {
      const parentRow = createRow(allocation, parentIndex);

      const childRows = Array.isArray(allocation?.PricingLotList)
        ? allocation.PricingLotList.map((childEntity, childIndex) =>
          createRow(childEntity, parentIndex, childIndex)
        )
        : [];

      return [parentRow, ...childRows];
    });

    let filteredData;
    if (IsHide) {
      filteredData = rowData?.filter((item) => {
        if (!item.isChild) {
          return item.BMV !== 0 || item.PriorMonthEMV !== 0 || item.EMV !== 0;

        } else {
          return item.BMV !== 0 || item.PriorMonthEMV !== 0 || item.EMV !== 0;

        }
      });
    } else {
      filteredData = rowData;
    }
    setPricingData(
      filteredData?.map((item) => {
        if (!item.isChild) {
          const children = filteredData.filter(
            (child) => child.PortfolioName === item.PortfolioName && child.isChild
          );
          const allChildrenChecked = children.every((child) => child.IsActual);
          return {
            ...item,
            IsActual: allChildrenChecked ? true : item.IsActual
          };
        }
        return item;
      })
    ); 
  };


  useEffect(() => {

    getPricingData(hideZeroPosition);
  }, [Gstate])

  const getDateFormatted = (params) => {
    const isoDate = params.value;
    if (isoDate != null) {
      const formattedDate = moment(isoDate).format("MM/DD/YYYY");
      return formattedDate;
    }
    else {
      return;
    }
  };
  const FormatCurrencyGrid = (params) => {

    var num = params.value;
    if (num !== undefined && num != null) {
      if (num === 0) {
        return;
      } else {
        const isNegative = num < 0;
        const formattedValue = isNegative
          ? `($${Math.abs(num).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })})`
          : `$${num.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}`;

        const style = isNegative ? { color: 'red' } : null;

        return <span style={style}>{formattedValue}</span>;
      }
    }
    else {
      return <span></span>;
    }
  };
  const FormatSharesValue = (params) => {

    var num = params.value;
    if (num !== undefined && num != null) {
      if (num === 0) {
        return '';
      } else {
        const isNegative = num < 0;
        const formattedValue = isNegative
          ? `(${Math.abs(num).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })})`
          : `${num.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}`;

        const style = isNegative ? { color: 'red' } : null;

        return <span style={style}>{formattedValue}</span>;
      }
    }
    else {
      return <span></span>;
    }
  };
  const FormatpercentCurrencyGrid = (params) => {

    var num = params.value;

    if (num !== undefined && num != null) {
      if (num === 0) {
        num = 0;
      }
      const isNegative = num < 0;
      const formattedValue = isNegative
        ? `${(num).toLocaleString('en-US', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        })} %`
        : `${num.toLocaleString('en-US', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        })} %`;
      const style = isNegative ? { color: 'red' } : null;

      return <span style={style}>{formattedValue}</span>;

    } else {
      return <span></span>;
    }
  };

  const IsActualCheckOnChange = (params) => {
if(params.data.isChild===false)
{
    setPricingData((prevData) =>
      prevData.map((item) => {
          if (item.PortfolioName === params.data.PortfolioName) {

              return {
                ...item,
                IsActual: params.data.IsActual,
                
                //isUpdated: (params.data.IsActual === true && params.data.newReturn!=item.newReturn || params.data.EMV!=item.EMV)?true:false
              };
          }
        return item;
      })
    );
}
else
{
  setPricingData((prevData) => 
  prevData.map((item) => {
    
    if (item.isChild === true) {
     
      if (item.PortfolioName === params.data.PortfolioName && item.AssetLotId === params.data.AssetLotId) {
       
        return {
          ...item,
          IsActual: params.data.IsActual, 
        // isUpdated: (params.data.IsActual === true && params.data.newReturn!=item.newReturn || params.data.EMV!=item.EMV)?true:false
        };
      }
    }

   
    if (!item.isChild) {
      const children = prevData.filter(
        (child) => child.PortfolioName === item.PortfolioName && child.isChild
      )
      const allChildrenChecked = children.every((child) => child.IsActual);
      if (allChildrenChecked) {
        return {
          ...item,
          IsActual: true
        };
      } else {
        return {
          ...item,
          IsActual: false
        };
      }
    }
   return item;
  })
);
}
  };
  const deleteCheckChange = (e, params) => {
    if (!params.data.isChild) {

      setPricingData(value => (value.map(item => {
        if (item.PortfolioName === params.data.PortfolioName) {
          return { ...item, 'Isdel': e.target.checked }
        }
        else {
          return { ...item }
        }
      }
      )))
    }
    else {

      setPricingData(value => (value.map(item => {
        if (item.AssetLotId === params.data.AssetLotId) {
          return { ...item, 'Isdel': e.target.checked }
        }
        else {
          return { ...item }
        }
      }
      )))
    }
    const isChecked = e.target.checked;
    if (!params.data.isChild) {
      setportfolioIds(prevState => {
        if (isChecked) {

          return [...new Set([...prevState, params.data.PricingLotList[0].PortfolioId])];
        } else {

          return prevState.filter(id => id !== params.data.PricingLotList[0].PortfolioId);
        }
      });
    }
    else {
      setportfolioIds(prevState => {
        if (isChecked) {

          return [...new Set([...prevState, params.data.PortfolioId])];
        } else {

          return prevState.filter(id => id !== params.data.PortfolioId);
        }
      });
    }

  };

  const CurrentPositionOnchangeCalc = (params) => {
   
    const MainData = pricinglist?.flatMap((allocation, parentIndex) => {
      const parentRow = createRow(allocation, parentIndex);
      const childRows = Array.isArray(allocation?.PricingLotList)
        ? allocation.PricingLotList.map((childEntity, childIndex) =>
          createRow(childEntity, parentIndex, childIndex)
        )
        : [];
      return [parentRow, ...childRows];
    });
    const parentrow = MainData.filter((item) => item.PortfolioName === params.data.PortfolioName);
   
    // Find flows records count....
    const childrows = parentrow.filter((item) => item.isChild === true);
    const IsFlow = childrows.filter((items) => items.Flows !='0.0');
    const isflows=IsFlow.length>0?true:false;
   
    // Hedge Fund...
    if ((HF.includes(AssetType)) || ([19,20,21].includes(AssetType))) {
      if (params.data.isChild === false) {
        const newCurrentPosition = ThousandsSeparators(params.newValue);
        const TopBMV = parentrow[0].BMV;
        // child row...
        let Flowsval=0
          pricingData.map((item) => {
            if (item.isChild === true) {
              if (item.PortfolioName === params.data.PortfolioName) {
            const tot=item.BMV+item.Flows;
             Flowsval+=tot;
              }
            }
          })
        setPricingData((prevData) =>
          prevData.map((item) => {
            if (item.isChild === true) {
              if (item.PortfolioName === params.data.PortfolioName) {
              const fval=item.BMV+item.Flows;
                const Weight = isflows? (fval/Flowsval):item.BMV / TopBMV;
                const EMV = Weight * newCurrentPosition.replace(/,/g, '');
                const flowreturn=(EMV-item.BMV-item.Flows)/(item.BMV+item.Flows)*100;
                const calculatedreturn = ((EMV - item.BMV) / item.BMV) * 100
                return {
                  ...item,
                  newReturn: isflows?flowreturn:calculatedreturn||0,//Return
                    EMV: EMV||0,//Current Position
                  isUpdated: true
                };
              }
            }
            return item;
          })
        );
        // Parent row...
        setPricingData((prevData) =>
          prevData.map((item) => {
            if (item.isChild === false) {
              if (item.PortfolioName === params.data.PortfolioName) {
                return {
                  ...item,
                  EMV: ThousandsSeparators(params.newValue), //Current Position
                  isUpdated: true
                };
              }
            }
            return item;
          })
        );
      }
    }
    // PE ,RE & HybridFund.......
    else if (PE.includes(AssetType)) {

      const newCurrentPosition = ThousandsSeparators(params.newValue);
      const TopBMV = parentrow[0].BMV;
      // child row...
      setPricingData((prevData) =>
        prevData.map((item) => {
          if (item.isChild === true) {
            if (item.PortfolioName === params.data.PortfolioName) {
                const Weight = item.BMV / TopBMV;
                const EMV = Weight * newCurrentPosition.replace(/,/g, '');
                const calculatedReturn = ((newCurrentPosition.replace(/,/g, '') - item.Flows - item.BMV) / (item.BMV + item.Flows) * 100);
                return {
                    ...item,
                    newReturn: calculatedReturn||0,//calculatedReturn
                    EMV: EMV||0,//Current Position
                    isUpdated: true
              };
            }
          }
          return item;
        })
      );
      // Parent row...
      setPricingData((prevData) =>
        prevData.map((item) => {
          if (item.isChild === false) {
            if (item.PortfolioName === params.data.PortfolioName) {
              return {
                ...item,
                EMV: ThousandsSeparators(params.newValue),
                isUpdated: true

              };
            }
          }
          return item;
        })
      );

    }
    else if (ismarket) {
      const newCurrentPosition = ThousandsSeparators(params.newValue);
      const TopBMV = parentrow[0].BMV;
      const contrbution = 0;
      const sells = 0;
      // child row...
      setPricingData((prevData) =>
        prevData.map((item) => {
          if (item.isChild === true) {
            if (item.PortfolioName === params.data.PortfolioName) {
              const Weight = item.BMV / TopBMV;
              const EMV = Weight * newCurrentPosition.replace(/,/g, '');
              const Calculatedreturnvalue = ((EMV - item.BMV - (contrbution + sells)) / (item.BMV + contrbution));
              return {
                ...item,
                newReturn: Calculatedreturnvalue||0,// Return
                EMV: EMV||0,//Current Position(EMV),
                isUpdated: true
              };
            }
          }
          return item;
        })
      );
    }
  }
  const CheckboxRendererMenu = (props) => {
    const delprop = props.data;
    return (
      <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>


        <input type='checkbox' checked={delprop.Isdel} onChange={(e) => { deleteCheckChange(e, props) }} />


      </div>
    );
  };
  const columnDefs = [
    {
      headerName: 'Portfolio Name',
      field: 'PortfolioName',
      hide: true,
    },
    { headerName: 'ShareClass Name', field: 'ShareClassName', editable: false },
    { headerName: 'Lot Name', field: 'AssetLotName', editable: false },
    { headerName: `EMV for ${moment(lastDateOfPreviousMonth).format("MM/DD/yyyy")}`, cellRenderer: FormatCurrencyGrid, cellStyle: { textAlign: "right" }, field: 'PriorMonthEMV', editable: false },
    { headerName: `BMV for ${moment(firstDateOfMonth).format("MM/DD/yyyy")}`, field: 'BMV', cellRenderer: FormatCurrencyGrid, cellStyle: { textAlign: "right" }, editable: false },
    { headerName: `Flows`, field: 'Flows', cellRenderer: FormatCurrencyGrid, cellStyle: { textAlign: "right" }, editable: false },
    { headerName: 'NAV', field: 'NAV', cellRenderer: FormatCurrencyGrid, cellStyle: { textAlign: "right" }, editable: false },
    { headerName: 'Shares', field: 'Shares', cellRenderer: FormatSharesValue, cellStyle: { textAlign: "right" }, editable: false },
    {
      headerName: 'Return Value', field: 'newReturn',
      cellRenderer: FormatpercentCurrencyGrid,
      cellStyle: { textAlign: "right" },
      editable: (params) => params.data.isChild && (HF.includes(AssetType) || ([19,20,21].includes(AssetType))),

        onCellValueChanged: (params) => {

        const newReturn = params.newValue / 100;
        const rowData = pricinglist?.flatMap((allocation, parentIndex) => {
          const parentRow = createRow(allocation, parentIndex);

          const childRows = Array.isArray(allocation?.PricingLotList)
            ? allocation.PricingLotList.map((childEntity, childIndex) =>
              createRow(childEntity, parentIndex, childIndex)
            )
            : [];
          return [parentRow, ...childRows];
        })
        const pdata = rowData.filter((item) => item.PortfolioName === params.data.PortfolioName);
        // HedgeFund....
        if (HF.includes(AssetType) || ([19,20,21].includes(AssetType)) ) {
          let totalEMV = 0;
          setPricingData((prevData) =>
            prevData.map((item) => {
              if (item.isChild === true) {
                if (item.PortfolioName === params.data.PortfolioName) {
                  if (item.AssetLotId === params.data.AssetLotId) {
                    const ret = parseFloat(1 + parseFloat(newReturn));
                    const EMV = parseFloat(item.BMV * ret);
                    totalEMV += EMV;
                    return {
                      ...item,
                      EMV: EMV,//Current Position
                      isUpdated: true
                    };
                  }
                  else {
                    totalEMV = totalEMV + item.EMV;
                  }
                }
              }
              return item;
            })
          );
          setPricingData((prevData) =>
            prevData.map((item) => {

              if (item.isChild === false && item.PortfolioName === params.data.PortfolioName) {
                return {
                  ...item,
                  EMV: totalEMV,
                  isUpdated: true

                };
              }
              return item;
            })
          );
        }
        // PE,RE & HybridFund....
        else if (PE.includes(AssetType)) {
          let totalEMV = 0;
          setPricingData((prevData) =>
            prevData.map((item) => {
              if (item.isChild === true) {
                if (item.PortfolioName === params.data.PortfolioName) {
                  if (item.AssetLotId === params.data.AssetLotId) {
                    const ret = parseFloat(1 + parseFloat(newReturn));
                    const EMV = parseFloat(item.BMV + item.Flows * ret)
                    totalEMV += EMV;

                    return {
                      ...item,
                      EMV: EMV,// Current Position 
                      isUpdated: true
                    };
                  }
                  else {
                    totalEMV += item.EMV;
                  }
                }
              }
              return item;
            })
          );
          setPricingData((prevData) =>
            prevData.map((item) => {

              if (item.isChild === false && item.PortfolioName === params.data.PortfolioName) {
                return {
                  ...item,
                  EMV: totalEMV,
                  isUpdated: true

                };
              }
              return item;
            })
          );
        }
        // Marketable Securities
        else if (ismarket) {

        }
      },
    },
    {
      headerName: `Current Position ${moment(lastDateOfMonth).format("MM/DD/yyyy")}`, field: 'EMV', cellRenderer: FormatCurrencyGrid, cellStyle: { textAlign: "right" }, editable: (params) => !params.data.isChild,
      onCellValueChanged: (params) => { CurrentPositionOnchangeCalc(params) }

    },
    { headerName: 'Valuation Date', field: 'ValuationDate', valueFormatter: getDateFormatted, editable: false },
    { headerName: 'Posted On', field: 'PostedOn', valueFormatter: getDateFormatted, editable: false },
    { headerName: 'Posted By', field: 'PostedBy', editable: false },

    {
      field: 'IsActual',
      headerName: 'Actual',
      cellRenderer: 'agCheckboxCellRenderer',
      cellEditor: 'agCheckboxCellEditor',
      editable: true,
      suppressKeyboardEvent: (params) => params.event.key === ' ',
      onCellValueChanged: IsActualCheckOnChange,
    },
    {
      field: 'Isdel',
      headerName: "Delete",
      cellRenderer: CheckboxRendererMenu,
      editable: false,

    }
  ];
  const ThousandsSeparators = (num) => {
    if (num != undefined) {
      let num_parts = num.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
    }
  }

  const gridOptions = {
    columnDefs: columnDefs,
    rowData: pricingData,
    animateRows: true,
    treeData: true,
    groupDefaultExpanded: -1,
    getDataPath: (data) => {
      if (data.isChild) {
        return [data.parentPortfolioName, `C-${data.childIndex} ${data.PortfolioName}`];
      }
      return [data.PortfolioName];
    },
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: 'Portfolio Name',
      field: 'PortfolioName',
      minWidth: 450,
      cellRendererParams: {
        suppressCount: true,
      },
      pinned: "left",
      editable: false,
      headerClass: "ag-grid-BR"
    }
  }, []);

  const defaultDef = {
    flex: 1,
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: true,
    cellDataType: false,
    resizable:true
  };
  let Level = ([{ BreadCrumb: "Pricing >", Routes: `${UrlPath.Valuation}` }]);
  Level = [...Level, { BreadCrumb: `${currentAsset.AssetName}` }
  ];

  const navigateToPricing = () => {
    history(`${UrlPath.Valuation}${params.AssetId}`, { state: { PricingDate: SelectedDate,HideZeroBalance:hideZeroPosition,HideActivePortfolios:hidePortfolios } })
  }

  const savePricing =async (mode, attempts) => {
    // const syncButton=document.getElementById("SyncButtonPostPricing");
    // syncButton.click();      
    setTimeout(() => {
    const Updateddata = pricingData?.filter((item) => {
      if (item.isUpdated) {
        return item;
      }
    });
    const childItems = Updateddata.filter(item => item.isChild);
    // const allLots = childItems.length > 0
    //   ? pricingData?.filter(lot => lot.PortfolioId == childItems[0].PortfolioId)
    //   : [];
    const lst = childItems
      .map(item => ({

        "PortfolioId": item.PortfolioId || item.PricingLotList[0].PortfolioId,
        "ValuationDate": moment(SelectedDate).format("MM-DD-yyyy"),
        "AssetId": params.AssetId,
        "AssetLotId": item.AssetLotId || 0,
        "ROR": item.newReturn || 0,
        "BMV": item.BMV+item.Flows|| 0,
        "EMV": item.EMV || 0,
        "Shares": item.IsShareBased ? item.Shares : null,
        "NAV": item.IsShareBased ? item.NAV : null,
        "EstimateActual": item.IsActual ? "A" : "E",
        "ModifiedBy": UserId

      }));
      if(lst.length>0)
      {
        setLoading(true);
    sbaAxios({
      url: `${postpricingdata}`,
      method: 'post',
      data: lst,
    })
      .then(() => {
        toast.success("pricing Updated Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
        if (mode === "Save") {
          setLoading(false);
          dispatch(getAssetPricingAction(params.AssetId, formattedSelectDate))
        }
        else if (mode === "SaveClose") {
          history(`${UrlPath.Valuation}${params.AssetId}`, { state: { PricingDate: SelectedDate,HideZeroBalance:hideZeroPosition,HideActivePortfolios:hidePortfolios } })

        }
      }).catch(() => {
        toast.error("Error updating Data -pricing", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
        setLoading(false);
      });
      }
    
    }, 0);
  }


  const deletePricing = () => {
    const portfolioIdsString = Array.isArray(portfolioIds) ? portfolioIds.length > 1 ? portfolioIds.join(',') : portfolioIds : '';
    const selectedDateFormatted = moment(SelectedDate).format("MM-DD-yyyy");
    const requestUrl = `${DeletePricing}/${portfolioIdsString},${params.AssetId},${selectedDateFormatted}`;

    sbaAxios({
      url: requestUrl,
      method: 'get',
    })
      .then(() => {
        toast.success("pricing Deleted Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        })

        dispatch(getAssetPricingAction(params.AssetId, formattedSelectDate))
        setportfolioIds([]);
      }).catch(() => {
        toast.error("Error updating delete-pricing", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
      });
  }
  return (


    <div id="PostPricing">
      {isPricinggridLoading ? <><LoadingScreen /></> : <>
        <TopBar label={"Post Pricing"} />



        <div id="content" className="mainContentData taxDetails">
          <BreadCrumbs Levels={Level} />
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-2">
                <label htmlFor="select fund" className="mb-1">
                  {" "}
                  Asset
                </label>
                <AssetDropDown
                  className="w-100"
                  value={currentAsset}
                  onChange={AssetDDChanged}
                  data={AssetListDDL}
                />
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label className="mb-1">Price Date</label>
                    <SBDatePicker 
                      value={moment(SelectedDate)}
                      onChange={PriceDatechange}
                      format="MM/DD/YYYY"
                      onBlur={priceDateOnBlur}
                      onClose={priceDateOnClose}
                      />
                  </div>
                  <div className="col-md-8 d-flex align-items-end">
                    <div className="">
                      <label className="me-2">
                        <input
                          className="me-1"
                          type="checkbox"
                          defaultChecked={hideZeroPosition}
                          onChange={(e) => {
                            SetHideZeroPosition((value) => !value);
                            gobtnClick();
                          }}
                        />
                        <span>Hide Zero Balances</span>
                      </label>
                      <label className="me-2">
                        <input
                          className="me-1"
                          type="checkbox"
                          defaultChecked={hidePortfolios}
                          onChange={(e) => {
                            SetHidePortfolios((value) => !value);
                            gobtnClick();
                          }}
                        />
                        <span>Hide Inactive Portfolios</span>
                      </label>
                    </div>
                    <div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4"></div>
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    onClick={gobtnClick}
                  >
                    Enter
                  </button>
                  {/* <button
                    // type="submit"
                    id="SyncButtonPostPricing"
                    className="p-sm-btn mx-1"
                    onClick={async() => { await gridRef.current.api.stopEditing(); }}
                  >
                    Sync
                  </button> */}
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    onClick={() => savePricing("Save", 0)}
                  >
                    Save
                  </button>
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    onClick={() => savePricing("SaveClose" ,0)}
                  >
                    Save & Close
                  </button>
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    onClick={deletePricing}
                  >
                    Delete
                  </button>
                  <button className="s-sm-btn mx-1" onClick={navigateToPricing}> Cancel</button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            {isPricinggridLoading ? (
              <LoadingScreen />
            ) : (
              <>
                <div
                  className="ag-theme-alpine"
                  style={{ height: "70vh", width: "100%" }}
                >
                  <AgGridReact
                   // stopEditingWhenGridLosesFocus={true}
                    rowData={pricingData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    autoGroupColumnDef={autoGroupColumnDef}
                    defaultColDef={defaultDef}
                    ref={gridRef}
                    onCellMouseOut={async()=>{ await gridRef.current.api.stopEditing();}}
                    getRowClass={(e) => { if (e.data.parentPortfolioName === null) { return "sbGridParentRow" } }}
                  />
                </div>
              </>
            )
            }
          </div>
        </div>
      </>
      }
        <ToastContainer />
    </div>
  );


}